import ArticleLayout from "@/pages/articles/components/ArticleLayout";

export default function YoybuyKakobuySravnenie() {
  return <ArticleLayout slug="yoybuy-kakobuy-sravnenie" />;
}